export const VISIBLE_ITEMS_CLASS =
  '[--items-visible:2.15] [--reco-gap:0.75rem] [--card-max:20rem] @xl:[--items-visible:3.5] @4xl:[--items-visible:4.5] @min-[88rem]:[--items-visible:5.5] @min-[104rem]:[--items-visible:6.5] @min-[120rem]:[--items-visible:7.5] @min-[136rem]:[--items-visible:8.5]';

export const INITIAL_RENDER_COUNT = 5;

export const LOADING_ITEM_COUNT = 9;
